import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { RouterModule } from '@angular/router';
import { tap } from 'rxjs/operators';
import { NgbModule, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PdfViewerModule } from 'ng2-pdf-viewer';

import {
  BreadcrumbComponent,
  ConfirmDialogComponent,
  FieldValidationComponent,
  FileDownloadComponent,
  FilePreviewComponent,
  FileUploadComponent,
  FormValidationComponent,
  HomeTableFooterComponent,
  LoginInProgressComponent,
  NotificationComponent,
  SessionExpiredComponent,
} from './components';

import {
  BatchItemsPipe,
  BooleanPipe,
  FunctionPipe,
  NoDataPipe,
  ParseArrayPipe,
  PrefixPipe,
  SafePipe,
  SuffixPipe,
} from './pipes';

import {
  ActivateDirective,
  CollapseContainerDirective,
  CollapseParentDirective,
  CollapseBodyDirective,
  CollapseHeaderDirective,
  ColumnHeaderDirective,
  ImageDefaultDirective,
  LoadHtmlDirective,
  SecuredDirective,
  SelectPlaceholderDirective,
  SelectUrlInputDirective,
  TableScrollDirective,
} from './directives';

export function initializeApp(http: HttpClient, appConfigPath, appConfig) {
  const initResult = () => {
    return new Promise((resolve, reject) => {
      const paths = [...appConfigPath];

      const result = paths
        .filter((m) => m != null)
        .map((path) => {
          return http
            .get(path)
            .pipe(
              tap((data) => {
                Object.assign(appConfig, data);
              }),
            )
            .toPromise();
        });

      Promise.all(result)
        .then(() => {
          resolve(undefined);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };
  return initResult;
}

@NgModule({
  imports: [CommonModule, RouterModule, NgbModule, PdfViewerModule],
  declarations: [
    BreadcrumbComponent,
    ConfirmDialogComponent,
    FieldValidationComponent,
    FileDownloadComponent,
    FilePreviewComponent,
    FileUploadComponent,
    FormValidationComponent,
    HomeTableFooterComponent,
    LoginInProgressComponent,
    NotificationComponent,
    SessionExpiredComponent,

    BatchItemsPipe,
    BooleanPipe,
    FunctionPipe,
    NoDataPipe,
    ParseArrayPipe,
    PrefixPipe,
    SafePipe,
    SuffixPipe,

    ActivateDirective,
    CollapseContainerDirective,
    CollapseParentDirective,
    CollapseBodyDirective,
    CollapseHeaderDirective,
    ColumnHeaderDirective,
    ImageDefaultDirective,
    LoadHtmlDirective,
    SecuredDirective,
    SelectPlaceholderDirective,
    SelectUrlInputDirective,
    TableScrollDirective,
  ],
  entryComponents: [ConfirmDialogComponent, LoginInProgressComponent, SessionExpiredComponent],
  exports: [
    BreadcrumbComponent,
    ConfirmDialogComponent,
    FieldValidationComponent,
    FileDownloadComponent,
    FilePreviewComponent,
    FileUploadComponent,
    FormValidationComponent,
    HomeTableFooterComponent,
    LoginInProgressComponent,
    NotificationComponent,
    SessionExpiredComponent,

    BatchItemsPipe,
    BooleanPipe,
    FunctionPipe,
    NoDataPipe,
    ParseArrayPipe,
    PrefixPipe,
    SafePipe,
    SuffixPipe,

    ActivateDirective,
    CollapseContainerDirective,
    CollapseParentDirective,
    CollapseBodyDirective,
    CollapseHeaderDirective,
    ColumnHeaderDirective,
    ImageDefaultDirective,
    LoadHtmlDirective,
    SecuredDirective,
    SelectPlaceholderDirective,
    SelectUrlInputDirective,
    TableScrollDirective,
  ],
  providers: [NgbActiveModal],
})
export class RenciWebClientModule {}
